module.exports = __webpack_public_path__ + "img/precoSinecom.a4ca64ce.png";